import api from "./axios.service";
const axios = api;

async function loadAliases() {
    try {
        let response = await axios.post('/elastic/loadAliases', {});
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function removeSuggestionsWithSimilarAnswers() {
    try {
        let response = await axios.post('/elastic/removeSuggestionsWithSimilarAnswers', {});
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function removeSuggestions(payload) {
    try {
        let response = await axios.post('/elastic/removeSuggestions', payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function getRemovedKeywords() {
    try {
        let response = await axios.get('/elastic/removedKeywords');
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    loadAliases,
    removeSuggestionsWithSimilarAnswers,
    removeSuggestions,
    getRemovedKeywords
}
